export default __webpack_public_path__ + "static/email-templates-insert-template-f9996c88005ae3afbc033890bca17717.mp4";